<template>
  <div class="left_wrap">
    <!-- <img  :src="userInfo.companyInfo && userInfo.companyInfo.avatar" alt> -->
    <div class="img" :style="'background-image: url(' + avatar + ')'"></div>
    <div class="name">{{ userInfo.name }}</div>
    <p class="remain" v-if="this.name !== 'history'">
      账号余额
      <span>{{ balance | jifen }}</span>
    </p>
    <div class="dashline"></div>
    <ul>
      <li>
        <router-link
          :to="{ name: 'order-list', query: { name: this.name } }"
          :class="{ actived: state == '1' }"
          >订单管理</router-link
        >
      </li>
      <!-- <li>
        <router-link
          v-if="this.name !== 'history'"
          :to="{ name: 'quyundong-order-list' }"
          :class="{ actived: state == '4' }"
          >场地预定</router-link
        >
      </li> -->
      <li>
        <router-link
          v-if="this.name !== 'history'"
          :to="{ name: 'user-address' }"
          :class="{ actived: state == '2' }"
          >地址管理</router-link
        >
      </li>
      <li>
        <router-link
          :to="{ name: 'coupon-list' }"
          :class="{ actived: state == '4' }"
          >优惠券</router-link
        >
      </li>
      <li>
        <router-link
          :to="{ name: 'refund-list' }"
          :class="{ actived: state == '3' }"
          >售后记录</router-link
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      balance: 0,
      avatar: "",
      userInfo: "",
      currency_rate: 1,
      name: ""
    };
  },
  props: {
    state: String
  },
  mounted() {
    this.name = window.sessionStorage.getItem("name");
    if (localStorage.getItem("currency_rate")) {
      this.currency_rate = localStorage.getItem("currency_rate");
    }
    this.username = this.$util.getSessionStorage("nick_name").nick_name;
    this.avatar = this.$util.getSessionStorage("avatar").avatar;
    this.getBalance();
    this.getData();
  },
  methods: {
    getData() {
      this.$reqGet("api/usercenter/info").then(res => {
        this.userInfo = res.data.data;
        if (this.userInfo.companyInfo && this.userInfo.companyInfo.avatar) {
          this.avatar = this.userInfo.companyInfo.avatar;
        }
      });
    },
    getBalance() {
      this.$reqGet("api/store/user/balance").then(res => {
        this.balance = parseFloat(
          res.data.data.balance / this.currency_rate
        ).toFixed(2);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.left_wrap {
  position: absolute;
  width: 200px;
  height: 450px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  .img {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    border-radius: 50%;
    background-size: cover;
    background-position: 50% 50%;
    margin-top: 20px;
  }
  .name {
    color: #333;
  }
  .remain {
    width: 158px;
    height: 35px;
    line-height: 35px;
    background: rgba(245, 245, 245, 1);
    border: 1px solid rgba(218, 218, 218, 1);
    border-radius: 3px;
    margin: 20px auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      color: #fc0010;
    }
  }
  .dashline {
    width: 154px;
    height: 2px;
    margin: 0 auto;
    border-bottom: 1px dashed rgba(218, 218, 218, 1);
  }
  ul {
    margin-top: 20px;
    li > a {
      color: #333;
      line-height: 40px;
      &.actived {
        color: #e2333f;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/left-userinfo.vue